// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobappdetails-card h6, .jobappdetails-card small {
  font-size: 0.75rem;
  text-align: center;
}
.jobappdetails-card .card-body i {
  color: #0A65CC;
  font-size: 1.75rem;
}
.jobappdetails-card .col > div {
  height: 49px;
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalApplicationContent/JobInformations/JobInformations.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,kBAAA;AADJ;AAIE;EACE,YAAA;AAFJ","sourcesContent":[".jobappdetails-card {\n  h6, small {\n    font-size: 0.75rem;\n    text-align: center;\n  }\n\n  .card-body i {\n    color: #0A65CC;\n    font-size: 1.75rem;\n  }\n\n  .col > div {\n    height: 49px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
